import { InstantDoubleValue } from "api/model/dataset/InstantDoubleValue";
import useCopyDataset from "hooks/useCopyDataset";
import { DatasetOverrideTitleConfig } from "models/dataset-models";
import { InputSwitch } from "primereact/inputswitch";
import React, { useId, useState } from "react";
import { Tooltip } from "react-tooltip";
import { I } from "services/lang/LanguageService";
import {
  formatISOToBasicDateFormat,
  formatValueWithGivenDecimalPlace,
  numberArrayToBooleanConverter,
} from "../dashboard/data-input-output-table/utils";

export const TitleOverrideAndDescriptionTemplate = ({
  data,
  version,
}: {
  data: DatasetOverrideTitleConfig;
  version?: number;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  useCopyDataset(isHovered, data.title, data.identifier);
  const tooltipId = useId();

  if (data.overriddenTitle || data.overriddenTitle === " ") {
    const title = data?.unit ? `, ${data.unit}` : "";
    if (!version || version === 1) {
      return (
        <div
          style={{
            whiteSpace: "break-spaces",
            wordBreak: "break-word",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "3px",
          }}
        >
          <Tooltip id={`custom-tooltip-class-${tooltipId}`} place="bottom" className="z-5" />
          <Tooltip id={`custom-target-icon-${tooltipId}`} place="bottom" className="z-5" />

          <div style={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
            <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
              <div>
                {I(data.overriddenTitle || "")}
                {data.unit &&
                  data.unit !== " " &&
                  data.overriddenTitle.length > 0 &&
                  data.overriddenTitle !== " " &&
                  ", "}
              </div>
              <div style={{ wordBreak: "keep-all" }}>
                {data.unit && data.unit !== " " ? data.unit : ""}
              </div>
            </div>
            <div
              className="non-printable flex gap-1"
              data-tooltip-id={`custom-tooltip-class-${tooltipId}`}
              data-tooltip-content={I(data.title || "") + title}
              style={{ paddingLeft: "3px" }}
            >
              <i
                className="pi pi-info-circle"
                onPointerEnter={() => setIsHovered(true)}
                onPointerLeave={() => setIsHovered(false)}
              />
            </div>
          </div>
          {data.description && (
            <span
              className="non-printable"
              data-tooltip-id={`custom-target-icon-${tooltipId}`}
              data-tooltip-content={I(data.description || "")}
            >
              <i className="pi pi-question-circle p-text-info" />
            </span>
          )}
        </div>
      );
    }
    if (version === 2) {
      return (
        <div
          style={{
            whiteSpace: "break-spaces",
            wordBreak: "break-word",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "3px",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Tooltip id={`custom-tooltip-class-${tooltipId}`} place="bottom" className="z-5" />
          <Tooltip id={`custom-target-icon-${tooltipId}`} place="bottom" className="z-5" />

          <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
            <div>
              {I(data.overriddenTitle || "")}
              {data.unit &&
                data.unit !== " " &&
                data.overriddenTitle.length > 0 &&
                data.overriddenTitle !== " " &&
                ", "}
            </div>
            <div style={{ wordBreak: "keep-all" }}>
              {data.unit && data.unit !== " " ? data.unit : ""}
            </div>
          </div>
          <div className="non-printable" style={{ display: "flex", gap: "8px" }}>
            <div
              data-tooltip-id={`custom-tooltip-class-${tooltipId}`}
              data-tooltip-content={I(data.title || "") + title}
            >
              <i
                className="pi pi-info-circle"
                onPointerEnter={() => setIsHovered(true)}
                onPointerLeave={() => setIsHovered(false)}
              />
            </div>
            {data.description && (
              <span
                className="non-printable"
                data-tooltip-id={`custom-target-icon-${tooltipId}`}
                data-tooltip-content={I(data.description || "")}
              >
                <i className="pi pi-question-circle p-text-info" />
              </span>
            )}
          </div>
        </div>
      );
    }
    if (version === 3) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "3px",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Tooltip id={`custom-tooltip-class-${tooltipId}`} place="bottom" className="z-5" />
          <Tooltip id={`custom-target-icon-${tooltipId}`} place="bottom" className="z-5" />

          <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
            <div>
              {I(data.overriddenTitle || "")}
              {data.unit &&
                data.unit !== " " &&
                data.overriddenTitle.length > 0 &&
                data.overriddenTitle !== " " &&
                ", "}
            </div>
            <div style={{ wordBreak: "keep-all" }}>
              {data.unit && data.unit !== " " ? data.unit : ""}
            </div>
          </div>
          <div className="non-printable" style={{ display: "flex", gap: "8px" }}>
            <div
              data-tooltip-id={`custom-tooltip-class-${tooltipId}`}
              data-tooltip-content={I(data.title || "") + title}
            >
              <i
                className="pi pi-info-circle"
                onPointerEnter={() => setIsHovered(true)}
                onPointerLeave={() => setIsHovered(false)}
              />
            </div>
            {data.description && (
              <span
                className="non-printable"
                data-tooltip-id={`custom-target-icon-${tooltipId}`}
                data-tooltip-content={I(data.description || "")}
              >
                <i className="pi pi-question-circle p-text-info" />
              </span>
            )}
          </div>
        </div>
      );
    }
  }
  if (!version || version === 1) {
    return (
      <div
        style={{
          whiteSpace: "break-spaces",
          wordBreak: "break-word",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "3px",
        }}
      >
        <Tooltip id={`custom-target-icon-${tooltipId}`} place="bottom" className="z-5" />
        <div
          style={{ display: "flex", alignItems: "justifyContent", flexWrap: "wrap", gap: "3px" }}
        >
          <div>
            {I(data.title || "")}
            {data.title && data.title !== " " && data.unit && data.unit !== " " && ", "}
          </div>
          <div style={{ wordBreak: "keep-all" }}>
            {data.unit && data.unit !== " " ? data.unit : ""}
          </div>
        </div>

        {data.description && (
          <div
            data-tooltip-id={`custom-target-icon-${tooltipId}`}
            data-tooltip-content={I(data.description || "")}
          >
            <i className="pi pi-question-circle p-text-info" />
          </div>
        )}
      </div>
    );
  }
  if (version === 2) {
    return (
      <div
        style={{
          whiteSpace: "break-spaces",
          wordBreak: "break-word",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          alignItems: "center",
          gap: "3px",
          flexGrow: "1",
          width: "100%",
        }}
      >
        <Tooltip id={`custom-target-icon-${tooltipId}`} place="bottom" className="z-5" />
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
          <div>
            {I(data.title || "")}
            {data.title && data.title !== " " && data.unit && data.unit !== " " && ", "}
          </div>
          <div style={{ wordBreak: "keep-all" }}>
            {data.unit && data.unit !== " " ? data.unit : ""}
          </div>
        </div>
        {data.description && (
          <div
            className="non-printable"
            data-tooltip-id={`custom-target-icon-${tooltipId}`}
            data-tooltip-content={I(data.description || "")}
          >
            <i className="pi pi-question-circle p-text-info" />
          </div>
        )}
      </div>
    );
  }
  if (version === 3) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          alignItems: "center",
          gap: "3px",
          flexGrow: "1",
          width: "100%",
        }}
      >
        <Tooltip id={`custom-target-icon-${tooltipId}`} place="bottom" className="z-5" />
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
          <div>
            {I(data.title || "")}
            {data.title && data.title !== " " && data.unit && data.unit !== " " && ", "}
          </div>
          <div style={{ wordBreak: "keep-all" }}>
            {data.unit && data.unit !== " " ? data.unit : ""}
          </div>
        </div>
        {data.description && (
          <div
            className="non-printable"
            data-tooltip-id={`custom-target-icon-${tooltipId}`}
            data-tooltip-content={I(data.description || "")}
          >
            <i className="pi pi-question-circle p-text-info" />
          </div>
        )}
      </div>
    );
  }
  return null;
};

export const NumberTypeTemplate = (
  data: Array<InstantDoubleValue>,
  unit: String,
  decimalPlaces?: number
) => {
  const tooltipId = useId();
  if (data.length > 0) {
    return (
      <>
        <Tooltip id={`labelData-${tooltipId}`} place="left" className="z-5" />
        <span
          data-tooltip-id={`labelData-${tooltipId}`}
          data-tooltip-content={formatISOToBasicDateFormat(data[0].key as string)}
        >
          {formatValueWithGivenDecimalPlace(data[data.length - 1].value, unit, decimalPlaces)}
        </span>
      </>
    );
  }
  return "-";
};

export const BooleanTypeTemplate = (
  data: Array<InstantDoubleValue>,
  onChange?: (value: boolean) => void
) => {
  const tooltipId = useId();
  if (data.length > 0) {
    return (
      <>
        <Tooltip id={`labelData-${tooltipId}`} place="left" className="z-5" />
        <span
          data-tooltip-id={`labelData-${tooltipId}`}
          data-tooltip-content={formatISOToBasicDateFormat(data[0].key as string)}
        >
          <InputSwitch
            checked={numberArrayToBooleanConverter(data)}
            onChange={e => (onChange ? onChange(e.value) : null)}
            disabled={!onChange}
          />
        </span>
      </>
    );
  }
  return "-";
};
